var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { ApplicationContext } from '../ApplicationContext';
import Routes from "./RoutesConfig";
import Loading from "../views/pages/Loading";
export default function RouteWrapper(props) {
    var children = props.children, isPrivate = props.isPrivate, isInitial = props.isInitial, path = props.path, rest = __rest(props, ["children", "isPrivate", "isInitial", "path"]);
    var applicationContext = useContext(ApplicationContext);
    var session = applicationContext.session;
    // Always direct to Loading screen
    if (!session.isInitialized && !isInitial) {
        return React.createElement(Loading, null);
    }
    //
    if (session.isInitialized) {
        /**
         * Redirect user to SignIn page if he tries to access a private route
         * without authentication.
         */
        if (isPrivate && !session.isLoggedIn) {
            return React.createElement(Navigate, { to: Routes.LOGIN.path });
        }
        /**
         * Redirect user to Main page if he tries to access non private route
         * (SignIn or SignUp) after being authenticated.
         */
        if (!isPrivate && session.isLoggedIn) {
            if (session.user.requiresOnBoarding) {
                return React.createElement(Navigate, { to: Routes.ON_BOARDING.path });
            }
            else {
                return React.createElement(Navigate, { to: Routes.ASSETS.path });
            }
        }
        // If logged in and visiting private page, always direct to on boarding
        if (isPrivate && session.isLoggedIn && session.user) {
            if (session.user.requiresOnBoarding && path !== Routes.ON_BOARDING.path) {
                return React.createElement(Navigate, { to: Routes.ON_BOARDING.path });
            }
        }
    }
    /**
     * If not included on both previous cases, redirect user to the desired route.
     */
    return children;
}
RouteWrapper.propTypes = {
    isPrivate: PropTypes.bool,
};
RouteWrapper.defaultProps = {
    isPrivate: false
};
